import React, { useEffect, useState } from 'react';
import BaseParametroCrud from './BaseParametroCrud';
import { useAuth } from '../../Auth/AuthContext';
import apiService from '../../Auth/apiService';

export default function AtencionesxRolddhh() {
    const { token } = useAuth();
    const [roles, setRoles] = useState([]);
    const [lineasAtencion, setLineasAtencion] = useState([]);
    async function fetchData(token) {
        try {
            const urlroles = '/parametros/listarrolesactivo'; 
            const responserol = await apiService.get(urlroles, token);
            setRoles(responserol.data || []);
            const urllineasatencion =  '/parametros/tipoatencionddhhactivos';
            const responselineasatencion = await apiService.get(urllineasatencion, token);
            setLineasAtencion(responselineasatencion.data || []);
        } catch (error) {
            console.error('Error fetching data:', error);
        } 
    };
    useEffect(() => {
        fetchData(token);    
    }, [token]);
    
    return (
        <BaseParametroCrud
            header={{
                title: 'Atenciones por rol DDHH',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Atenciones por rol DDHH'
            }}
            formTitle="Formulario atenciones por rol DDHH"
            loadUrl="/parametros/ddhh/listaratencionxrolddhh"
            saveUrl="/parametros/ddhh/guardarlistaratencionxrolddhh"
            alertTitle="Guardar atenciones por rol DDHH"
            defaultValues={{
                id: 0,
                intIdrol: '',
                intIdatencionddhh: '',
                bolActivo: false
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                intIdrol: row.intIdrol,
                intIdatencionddhh: row.intIdatencionddhh,
                bolActivo: row.bolActivo,
                rol: row.rol,
                tipoatencion: row.tipoatencion
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'rol', title: 'Rol' },
                { key: 'tipoatencion', title: 'Atención DDHH' },
                {
                    key: 'bolActivo',
                    title: 'Estado',
                    render: (row) => (row.bolActivo ? 'Activo' : 'Inactivo')
                }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="intIdatencionddhh">Atención DDHH</label>
                                <select
                                    {...register('intIdatencionddhh', { required: true })}
                                    className="form-control"
                                    id="intIdatencionddhh"
                                >
                                    <option value="">Seleccione...</option>
                                    {lineasAtencion.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.strNombre}
                                        </option>
                                    ))}
                                </select>
                                {errors.intIdatencionddhh && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="intIdrol">Rol</label>
                                <select
                                    {...register('intIdrol', { required: true })}
                                    className="form-control"
                                    id="intIdrol"
                                >
                                    <option value="">Seleccione...</option>
                                    {roles.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.rolRol}
                                        </option>
                                    ))}
                                </select>
                                {errors.intIdrol && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}